import { useState } from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import ActionButtons from '../ActionsButtons';
import EditAdministratorForm from '../EditAdministratorForm';
import Modal from '../../../../../../common/components/Modal';
import { Permission } from "../../../../../../components/SessionInfo";

function AdministratorsTableRow({ row, roles, triggerRefetch, permission }) {
  const formFields = {
    id: row.id,
    familyName: row.family_name,
    firstName: row.first_name,
    patronymic: row.patronymic,
    position: row.position,
    email: row.email,
    expiredKey: row.expired_key,
    expiredLicense: row.expired_license,
    existKeys: row.key_names,
    enable: row.enable,
    login: row.login,
    role: row.role,
  };
  const [editModalOpen, setEditModalOpen] = useState(false);

  const openEditModal = () => setEditModalOpen(true);
  const handleEditModalClose = () => setEditModalOpen(false);

  return (
    <>
      <TableRow sx={{'&:last-child th': {border: 0}}}>
        <TableCell>{row.family_name}</TableCell>
        <TableCell>{row.first_name}</TableCell>
        <TableCell>{row.patronymic}</TableCell>
        <TableCell>{row.position}</TableCell>
        <TableCell>{row.login}</TableCell>
        <TableCell><span title={roles.find(p => p.id === row.role)?.description ?? 'Данная роль не зарегистрирована'}>{roles.find(p => p.id === row.role)?.name ?? 'Неизвестно' }</span></TableCell>
        <TableCell>{row.email}</TableCell>
        <TableCell>{row.expired_license ? 'Да' : 'Нет'}</TableCell>
        <TableCell>{row.expired_key ? 'Да' : 'Нет'}</TableCell>
        <TableCell>
          {row.key_names.map((item) => (
            <p style={{margin: '4px 0'}} key={item.key_name}>{`${item.key_name}\n`}</p>
          ))}
        </TableCell>
        <TableCell>{row.enable ? 'Да' : 'Нет'}</TableCell>
        {
          (permission === Permission.WRITE)?
            <TableCell sx={{whiteSpace: 'nowrap'}}>
              <ActionButtons openEditModal={openEditModal} id={row.id} triggerRefetch={triggerRefetch}/>
            </TableCell>
          : ''
        }
      </TableRow>
      <Modal
          header="Редактирование учетной записи"
          width={700}
          open={editModalOpen}
          onClose={handleEditModalClose}
      >
        <EditAdministratorForm
          {...formFields}
          roles={roles}
          triggerRefetch={triggerRefetch}
          handleClose={handleEditModalClose}
        />
      </Modal>
    </>
  );
}

export default AdministratorsTableRow;
